import { render, staticRenderFns } from "./OrmSection.vue?vue&type=template&id=5d362c54&scoped=true"
import script from "./OrmSection.vue?vue&type=script&lang=js"
export * from "./OrmSection.vue?vue&type=script&lang=js"
import style0 from "./OrmSection.vue?vue&type=style&index=0&id=5d362c54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d362c54",
  null
  
)

export default component.exports